<template>
  <li :class="{ hidden: isHidden }" class="js-review-item">
    <p>
      {{ rating.description }}
    </p>
    <div class="meta">
      <div class="left">
        <span class="author">{{ rating.author }}</span>
        <Stars :with-count="true" :stars="rating.rating" />
      </div>
      <div class="right">
        <p>
          Pridané
          <time datetime="2019-05-21">{{ rating.created }}</time>
        </p>
      </div>
    </div>
  </li>
</template>

<script>
import Stars from "./Stars";

export default {
  props: ["isHidden", "rating"],

  components: {
    Stars,
  },
};
</script>
